module.exports = __webpack_public_path__ + "img/card-bg1@2x.2f9b3a66.png";